/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SrvProceedingClaimSnapshotRowResponse
 */
export interface SrvProceedingClaimSnapshotRowResponse {
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingClaimSnapshotRowResponse
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingClaimSnapshotRowResponse
     */
    creditorName: string;
    /**
     * 
     * @type {string}
     * @memberof SrvProceedingClaimSnapshotRowResponse
     */
    caseNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SrvProceedingClaimSnapshotRowResponse
     */
    registeredOn: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingClaimSnapshotRowResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the SrvProceedingClaimSnapshotRowResponse interface.
 */
export function instanceOfSrvProceedingClaimSnapshotRowResponse(value: object): value is SrvProceedingClaimSnapshotRowResponse {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('creditorName' in value) || value['creditorName'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('registeredOn' in value) || value['registeredOn'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function SrvProceedingClaimSnapshotRowResponseFromJSON(json: any): SrvProceedingClaimSnapshotRowResponse {
    return SrvProceedingClaimSnapshotRowResponseFromJSONTyped(json, false);
}

export function SrvProceedingClaimSnapshotRowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingClaimSnapshotRowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'creditorName': json['creditorName'],
        'caseNumber': json['caseNumber'],
        'registeredOn': (json['registeredOn'] == null ? null : new Date(json['registeredOn'])),
        'amount': json['amount'],
    };
}

export function SrvProceedingClaimSnapshotRowResponseToJSON(json: any): SrvProceedingClaimSnapshotRowResponse {
    return SrvProceedingClaimSnapshotRowResponseToJSONTyped(json, false);
}

export function SrvProceedingClaimSnapshotRowResponseToJSONTyped(value?: SrvProceedingClaimSnapshotRowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'creditorName': value['creditorName'],
        'caseNumber': value['caseNumber'],
        'registeredOn': value['registeredOn'] == null ? value['registeredOn'] : `${value['registeredOn'].getFullYear()}-${String(value['registeredOn'].getMonth()+1).padStart(2,'0')}-${String(value['registeredOn'].getDate()).padStart(2,'0')}`,
        'amount': value['amount'],
    };
}

